import React from "react";
import PropTypes from "prop-types";
import getStyled from "../../hooks/getStyled";
import { SFStack } from "../grid";
import SFTypography from "../typography";
import SFButton from ".";

const { styled } = getStyled();

const StyledSFButton = styled(SFButton)(({ theme, selected }) => ({
  /* Layout and Display */
  width: "100%", // Full width element
  display: "inherit", // Inherit the display property from the parent

  /* Base styles */
  padding: "10px",
  borderRadius: "4px",

  /* Borders */
  border: selected
    ? `1px solid ${theme.palette.blue300_1.main}` // Blue border when selected
    : `1px solid ${theme.palette.grey225.main}`, // Grey border when not selected

  /* Background Color */
  backgroundColor: selected
    ? theme.palette.blue50.main // Blue background when selected
    : theme.palette.grey50.main, // Grey background when not selected
}));

const DataCardNumeralTypography = styled(SFTypography)(({ theme }) => ({
  fontSize: "28px",
  lineHeight: "32px",
}));

const SFDataCardButton = ({
  selected = false, // Indicates whether the button is selected
  disabled = false, // Indicates whether the button is disabled
  handleClick = () => {}, // Function to handle button click

  // Icon to be displayed on the button. You can pass an icon like this:
  // icon={(props) => <SFShowChartIcon {...props} />}
  icon = () => <></>,

  numeral = 0, // The numeral value to be displayed on the button
  description = "Description", // The description text to be displayed on the button
}) => {
  const IconComponent = icon;

  return (
    <StyledSFButton
      variant="utility"
      disableRipple
      selected={selected}
      disabled={disabled}
      onClick={handleClick}
    >
      <SFStack direction="column" spacing={1} alignItems="stretch">
        <SFStack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <IconComponent
            color={disabled ? "grey350" : selected ? "grey450" : "grey400"}
            size="large"
          />
          <DataCardNumeralTypography variant="cardNumber">
            {numeral}
          </DataCardNumeralTypography>
        </SFStack>
        <SFTypography variant="h4" align="right">
          {description}
        </SFTypography>
      </SFStack>
    </StyledSFButton>
  );
};

SFDataCardButton.propTypes = {
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func,
  icon: PropTypes.elementType,
  numeral: PropTypes.number,
  description: PropTypes.string,
};

export default SFDataCardButton;
